import {
	CdkDrag,
	CdkDragPlaceholder,
	CdkDropList,
} from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';


import { RoundStickerComponent } from 'ib/internetbank-core/ib-components';
import { SvgEyeClosedModule } from 'ib/internetbank-core/ib-svg/svg-eye-closed/svg-eye-closed.module';
import { SvgEyeOpenedModule } from 'ib/internetbank-core/ib-svg/svg-eye-opened/svg-eye-opened.module';

import { CommonAppModule } from '../../../common/common-app.module';
import { PipeModule } from '../../../common/pipes/pipe.module';
import { UpdateStateService } from '../../../common/services/update-state.service';
import { ProductAliasEditorComponent } from '../../../products/common/product-alias-editor/product-alias-editor.component';
import { ProductBalanceComponentModule } from '../../../products/left-panel/product-balance/product-balance.module';
import { ProductFastMenuComponent } from '../../../products/left-panel/product-list/product-fast-menu/product-fast-menu.component';
import { ProductSuggestionListFacade } from '../../../products/left-panel/product-list/product-suggestion-list/product-suggestion-list.facade';
import { RefiApplicationItemComponent } from '../../../products/left-panel/product-list/refi-application-item/refi-application-item.component';
import { ProductsService } from '../../../products/products.service';
import { InsuranceSectionService } from '../../../sections/insurance-section/insurance-section.service';
import { BannersModule } from '../../../sections/main-section/banners/banners.module';
import { ConfirmationPopoverContentComponentModule } from '../../../shared/confirmation/endpoint-with-confirmation-executer/confirmation-popover-content/confirmation-overlaybox-content.module';
import { SvgCommonModule } from '../../../shared/svg/svg-common.module';
import { UiModule } from '../../../ui/ui.module';
import { ProductListService } from '../../product-list.service';


import { HiddenProductListToggleComponent } from './hidden-product-list/components/hidden-product-list.-toggle/hidden-product-list-toggle.component';
import { HiddenProductListComponent } from './hidden-product-list/hidden-product-list.component';
import { HiddenProductListFacade } from './hidden-product-list/hidden-product-list.facade';
import { MiniShowcaseComponent } from './mini-showcase/mini-showcase.component';
import { ProductListComponent } from './product-list/product-list.component';
import { ProductListGroupsComponent } from './product-list-groups/product-list-groups.component';
import { ProductListItemComponent } from './product-list-item/product-list-item.component';
import { ProductStickerStatusComponent } from './product-sticker-status/product-sticker-status.component';


export const ProductsModuleProviders = [
	ProductsService,
	ProductSuggestionListFacade,
	ProductListService,
	HiddenProductListFacade,
	InsuranceSectionService,
	UpdateStateService,
]


@NgModule({
	imports: [
		CommonModule,
		CommonAppModule,
		UiModule,
		PipeModule,
		SvgCommonModule,
		RouterModule,
		RoundStickerComponent,
		ProductBalanceComponentModule,
		ProductFastMenuComponent,
		BannersModule,
		CdkDropList,
		CdkDrag,
		CdkDragPlaceholder,
		SvgEyeOpenedModule,
		SvgEyeClosedModule,
		ConfirmationPopoverContentComponentModule,
		ProductStickerStatusComponent,
		ProductAliasEditorComponent,
		MiniShowcaseComponent,
	],
	declarations: [
		ProductListItemComponent,
		ProductListComponent,
		ProductListGroupsComponent,
		HiddenProductListToggleComponent,
		HiddenProductListComponent,
		RefiApplicationItemComponent,
	],
	exports: [
		ProductListItemComponent,
		ProductListComponent,
		ProductListGroupsComponent,
		HiddenProductListComponent,
		RefiApplicationItemComponent,
	],
	providers: [
		// ProductsService,
		// CreditOrderListFacade,
		// CardOrderListFacade,
		// ProductSuggestionListFacade,
		// ProductListService,
	],
})
export class ProductsModule { }
